import type { Summary as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/**
 * AppSchema's `Summary` carries thirteen figures; this maps the nine the offer builder has always
 * read. `artistBackend`, `promoterProfit`, `taxAmount` and `totalExpenses` are deliberately left
 * out -- the legacy selection never asked for them and nothing renders them, so widening the type
 * here would be a change of scope rather than a migration. Add them with their consumer.
 */
export type Summary = {
  artistPotential?: number;
  breakeven?: number;
  fixedExpenses?: number;
  gbor?: number;
  netPotential?: number;
  overage?: number;
  promoterPotential?: number;
  splitPoint?: number;
  variableExpenses?: number;
};

export const fromGql = (item: GQLItem): Summary =>
  take<Summary, GQLItem>(
    item,
    'artistPotential',
    'breakeven',
    'fixedExpenses',
    'gbor',
    'netPotential',
    'overage',
    'promoterPotential',
    'splitPoint',
    'variableExpenses',
  );
